import React, { useEffect, useRef } from 'react';
import { SCROLLSPEED } from "../../constants/constants";
import gsap from 'gsap';
import styles from './card.module.scss';

/**
* @color - color of card (violet or white);
* @text - text on card;
* @img - src to card image;
* @className - html class for card
*/

const AnimatedCard = ({
                        color = 'violet',
                        text,
                        img,
                        className,
                        classNameImg,
                        speedCard = 1,
                        speedImg = 1,
                        id = 'parallax',
                        start = 'top bottom',
                        end = 'bottom top',
                        ...params
}) => {

  const trigger = useRef();
  const targetCard = useRef();
  const targetImg = useRef();
  const timeline = useRef();


  useEffect(() => {
    const yCard = 760 * speedCard * SCROLLSPEED;
    const yImg = 760 * speedImg * SCROLLSPEED;

    const setY = gsap.quickSetter(targetCard.current, 'y', 'px');
    const setImgY = gsap.quickSetter(targetImg.current, 'y', 'px');

    timeline.current = gsap.timeline({
      scrollTrigger: {
        id,
        trigger: trigger.current,
        scrub: true,
        start,
        end,
        onUpdate: (e) => {
          setY(e.progress * yCard);
          setImgY(e.progress * yImg);
        }
      }
    }).to(targetImg.current, {...params, duration: 1.5});

    return () => {
      timeline?.current?.kill();
      trigger.current = null;
      targetCard.current = null;
      targetImg.current = null;
      timeline.current = null;
    }
  }, [id, speedCard, speedImg]);

  return (
    <div
      ref={trigger}
    >
      <div
        ref={targetCard}
        className={`
              ${styles.wrapper} ${color === 'violet' ? styles.violet : styles.white}
              ${className ? className : ''}
            `}
        >
        <div
          className={styles.blur}
        >
          <div className={`${styles.img} ${classNameImg}`} ref={targetImg}>
            <img src={img} alt="card img"/>
          </div>
        </div>
        <div className={styles.desc}>
          <h4 className={styles.text}>{text}</h4>
        </div>
      </div>
    </div>
  );
};

export default AnimatedCard;